import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class ContractInternalTx extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default ContractInternalTx
